import "./ComingSoonSkeleton.scss";

const ComingSoonSkeleton = () => {

  return (
    <div className="comingsoon__wrapper__skeleton">
      <div className="comingsoon__item__skeleton">
        <div className="comingsoon__info__skeleton">
          <div className="comingsoon__info__accent__skeleton"></div>
          <div className="comingsoon__info__subtitle__skeleton"></div>
          <div className="comingsoon__info__text__skeleton"></div>
          <div className="comingsoon__info__title__skeleton"></div>
          <div className="comingsoon__info__accent__skeleton--primary"></div>
        </div>
        <div className="comingsoon__timer__skeleton">
          <div className="comingsoon__timer__numbers__skeleton">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="numbers__item__skeleton"></div>
            ))}
          </div>
          <div className="comingsoon__timer__labels__skeleton">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="labels__item__skeleton"></div>
            ))}
          </div>
        </div>

        <div className="subscribe__comingsoon__skeleton">
          <div className="subscribe__comingsoon__text__skeleton"></div>
          <div className="subscribe__form__skeleton">
            <div className="subscribe__form__input__wrapper__skeleton"></div>
            <div className="subscribe__form__button__wrapper__skeleton"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonSkeleton;